var _path, _g, _g2, _g3, _g4, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1116 14H2.88836C1.29251 14 0 12.8444 0 11.4203V2.57972C0 1.15439 1.29383 0 2.88836 0H11.1116C12.7075 0 14 1.15557 14 2.57972V11.4203C14.0013 12.8444 12.7075 14 11.1116 14Z",
    fill: "url(#paint0_linear_26286_57750)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_26286_57750)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5.40039,
    width: 10,
    height: 1.2,
    rx: 0.6,
    fill: "white",
    fillOpacity: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_26286_57750)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7.7998,
    width: 10,
    height: 1.2,
    rx: 0.6,
    fill: "white",
    fillOpacity: 0.25
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_26286_57750)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 10,
    height: 1.2,
    rx: 0.6,
    fill: "white",
    fillOpacity: 0.25
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_26286_57750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16C9.01464 16 7 13.9854 7 11.5C7 9.01464 9.01464 7 11.5 7C13.9854 7 16 9.01464 16 11.5C16 13.9854 13.9854 16 11.5 16Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91738 10.9786L10.6829 9.94283C11.1777 9.27332 11.4252 8.93856 11.656 9.0093C11.8868 9.08005 11.8868 9.49062 11.8868 10.3118V10.3892C11.8868 10.6854 11.8868 10.8335 11.9815 10.9264L11.9865 10.9312C12.0832 11.0221 12.2373 11.0221 12.5455 11.0221C13.1003 11.0221 13.3776 11.0221 13.4714 11.1903C13.4729 11.1931 13.4744 11.1959 13.4759 11.1987C13.5644 11.3696 13.4038 11.5869 13.0826 12.0214L12.3171 13.0572C11.8222 13.7267 11.5748 14.0614 11.3439 13.9907C11.1131 13.9199 11.1131 13.5094 11.1131 12.6882L11.1131 12.6108C11.1131 12.3146 11.1131 12.1665 11.0185 12.0736L11.0135 12.0688C10.9168 11.9779 10.7627 11.9779 10.4544 11.9779C9.89972 11.9779 9.62236 11.9779 9.52863 11.8097C9.52707 11.8069 9.52556 11.8041 9.5241 11.8012C9.43561 11.6304 9.5962 11.4131 9.91738 10.9786Z",
    fill: "url(#paint1_linear_26286_57750)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_26286_57750",
    x: -6.81461,
    y: -3.41422,
    width: 27.6292,
    height: 18.8294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.4073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26286_57750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26286_57750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_26286_57750",
    x: -6.81461,
    y: -1.0148,
    width: 27.6292,
    height: 18.8294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.4073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26286_57750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26286_57750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_26286_57750",
    x: -6.81461,
    y: -5.81461,
    width: 27.6292,
    height: 18.8294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.4073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26286_57750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26286_57750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_26286_57750",
    x: -4.54728,
    y: -4.54728,
    width: 32.0946,
    height: 32.0946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.77364
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26286_57750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26286_57750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26286_57750",
    x1: -0.291667,
    y1: -1.67708,
    x2: 13.9271,
    y2: 14.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746EF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26286_57750",
    x1: 9.5,
    y1: 9.39063,
    x2: 14.0522,
    y2: 12.6941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectContent);
export default __webpack_public_path__ + "static/media/select-content.f0812f3a4f7b2d5f1d56c1ea48e5bfc1.svg";
export { ForwardRef as ReactComponent };